import { CandidateStatusColor } from "../../Enums/CandidateStatusColor";
import { ICandidateStatusDefinition } from "../../Typings/CandidateStatus";

// Mirrors CandidateStatusDefaults.All in crm.api (CRM.Core/Models/CandidateStatusDefault.cs).
// Used as a graceful fallback when the definitions endpoint is unavailable or still loading.
export const CANDIDATE_STATUS_DEFAULTS: readonly ICandidateStatusDefinition[] = [
  {
    color: CandidateStatusColor.White,
    sortOrder: 1,
    label: "No Status",
    description: "No status assigned",
    isSystemManaged: true,
  },
  {
    color: CandidateStatusColor.Green,
    sortOrder: 2,
    label: "Contacted",
    description: "Text or email communication recorded",
    isSystemManaged: true,
  },
  {
    color: CandidateStatusColor.Blue,
    sortOrder: 3,
    label: "Engaged",
    description: "Candidate has responded or shown active interest",
    isSystemManaged: false,
  },
  {
    color: CandidateStatusColor.Purple,
    sortOrder: 4,
    label: "In Review",
    description: "Being evaluated for current opportunities",
    isSystemManaged: false,
  },
  {
    color: CandidateStatusColor.Yellow,
    sortOrder: 5,
    label: "Follow Up",
    description: "Needs additional outreach or nurturing",
    isSystemManaged: false,
  },
  {
    color: CandidateStatusColor.Red,
    sortOrder: 6,
    label: "Not a Fit",
    description: "Not a match for current opportunities",
    isSystemManaged: false,
  },
];
